import { render, staticRenderFns } from "./ModalImportacaoExcel.vue?vue&type=template&id=2c6413c2&scoped=true"
import script from "./ModalImportacaoExcel.vue?vue&type=script&lang=js"
export * from "./ModalImportacaoExcel.vue?vue&type=script&lang=js"
import style0 from "./ModalImportacaoExcel.vue?vue&type=style&index=0&id=2c6413c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6413c2",
  null
  
)

export default component.exports